import { defineStore } from "pinia";
import { Singleflight } from '@voghion/fe-util'
import {
  getMessageNotify,
  getMessageNotifyList,
  postClearNotifyUnread,
} from "@/api";

const singleflight = Singleflight.getInstance()

interface messageBoxNotifyVoType {
  content: string;
  icon: string;
  pushTime: string;
  read: boolean;
  skipUrl: string;
  title: string;
  unreadNum: number;
}

interface notifyType {
  messageBoxNotifyVo: messageBoxNotifyVoType;
  notifyTitle: string;
  type: 0 | 1;
}

export const useNotifyStore = defineStore("notify", {
  state: () => {
    return {
      //务通知列表
      notify: {} as notifyType,
      notifyList: [] as Array<messageBoxNotifyVoType>,
      //务通知列表
      notifyVip: {} as notifyType,
      notifyListVip: [] as Array<messageBoxNotifyVoType>,
      loading: false as boolean,
    };
  },
  actions: {
    getNotify() {
      return singleflight.do(`getMessageNotify`,async () => {
        this.loading = true;
        getMessageNotify()
          .then((res: any) => {
            if (res.rtn_code === "0000") {
              (res?.data || []).forEach((i) => {
                if (i.type === 1) {
                  this.notify = i;
                } else if (i.type === 2) {
                  this.notifyVip = i;
                }
              });
            }
          })
          .finally(() => {
            this.loading = false;
          });
      })
    },
    getNotifyList(isVip = false) {
      this.loading = true;
      getMessageNotifyList({ vip: isVip })
        .then((res: any) => {
          if (res.rtn_code === "0000") {
            if (isVip) {
              this.notifyListVip = res?.data?.notifyList || [];
            } else {
              this.notifyList = res?.data?.notifyList || [];
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clearNotifyUnread(isVip = false, pageType?: "list") {
      this.loading = true;

      postClearNotifyUnread({ vip: isVip })
        .then((res: any) => {
          if (res.rtn_code === "0000") {
            if (pageType === "list") {
              this.getNotifyList(isVip);
            }
            this.getNotify();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    clearUnread(isVip) {
      if (isVip) {
        this.notifyVip = {
          ...this.notifyVip,
          messageBoxNotifyVo: {
            ...this.notifyVip.messageBoxNotifyVo,
            unreadNum: 0,
          },
        };
      } else {
        this.notify = {
          ...this.notify,
          messageBoxNotifyVo: {
            ...this.notify.messageBoxNotifyVo,
            unreadNum: 0,
          },
        };
      }
    },
  },
});
